<template>
  <div>
    <h1 class="text-center pt-12">
      CRM Priser
    </h1>
    <Pricetable />
    <Quote
      color="light-blue"
      text="Mest prisvärda CRM systemet på marknaden"
      subtext="- Sarah, Göteborg"
    />
  </div>
</template>

<script>
import Pricetable from '@/components/Pricetable'
import Quote from '@/components/Quote'

export default {
  components: {
    Pricetable,
    Quote,
  },
}
</script>
